// extracted by mini-css-extract-plugin
export default {"iconWrapper":"search_iconWrapper__TiDBC","input":"search_input__CYn4f","button":"search_button__oEWPJ"};